{
  "branding": {
    "frontdesk-attribution": "S technologií FrontDesk+",
    "practice-logo": "Logo {{name}}"
  },
  "validation": {
    "required": "Toto pole je povinné",
    "invalid-url": "Prosím zadejte platnou URL adresu",
    "pin-too-short": "PIN musí mít alespoň 4 znaky",
    "pin-default-rejected": "Standardní PIN 0000 není povolen. Přidělte prosím svůj vlastní PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Zpět",
    "next": "Další",
    "cancel": "Zrušit",
    "confirm": "Potvrdit",
    "done": "Hotovo",
    "retry": "Zkusit znovu",
    "clear": "Vymazat",
    "close": "Zavřít",
    "verifying": "Ověřování...",
    "select": "Vybrat",
    "minutes": "minut",
    "clock": "",
    "gender": {
      "M": "Muž",
      "W": "Žena",
      "D": "Různé",
      "U": "Neznámé"
    },
    "insurance": {
      "GKV": "Zákonné",
      "PKV": "Soukromé",
      "SELFPAY": "Samoplatba"
    },
    "scroll-up": "Posunout nahoru",
    "scroll-down": "Posunout dolů"
  },
  "settings": {
    "device-reset": {
      "title": "Resetovat zařízení",
      "description": "Odstranit připojení k ordinaci, nastavení a PIN tohoto zařízení.",
      "confirmation": "Zařízení bude nutné znovu nastavit. Konfigurace SOL a údaje pacientů v inSuite zůstanou beze změny.",
      "cancel": "Zrušit",
      "confirm": "Resetovat nyní"
    },
    "title": "Nastavení",
    "save": "Uložit",
    "save-success": "Nastavení uloženo",
    "save-error": "Chyba při ukládání nastavení",
    "load-error": "Chyba při načítání nastavení",
    "pin": {
      "title": "Vyžadován PIN",
      "description": "Prosím zadejte svůj PIN pro přístup k nastavení.",
      "error": "Nesprávný PIN. Prosím zkuste to znovu.",
      "backspace": "Smazat poslední číslici"
    },
    "connection": {
      "title": "Připojení",
      "description": "Nastavení připojení k serveru Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Název zařízení",
      "device-name-placeholder": "např. Recepce, místnost 1, kiosek",
      "device-name-hint": "Název pro identifikaci na přístrojové desce Bridge",
      "kim-address": "Adresa KIM (volitelné)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Připojení úspěšné",
      "error": "Připojení selhalo",
      "api-unreachable": "DocCirrus API nedostupné",
      "status-title": "Stav připojení",
      "status": {
        "api": "API připojeno",
        "ti": "Telematická infrastruktura",
        "card-reader": "K dispozici čtečka karet",
        "medical-card": "Karta ordinace (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (z inSuite)",
      "sol-token-hint": "Zkopírujte ho ze správy Bridge v inSuite. Je potřeba pro připojení.",
      "sol-token-show": "Zobrazit token",
      "sol-token-hide": "Skrýt token",
      "bridge-unreachable": "Bridge není dostupný. Zkontrolujte adresu a port.",
      "diagnostic-id": "ID diagnostiky: {{id}}",
      "scan-qr": "Naskenovat QR kód",
      "scan-title": "Naskenovat QR kód Bridge",
      "scan-manual": "Zadat ručně"
    },
    "terminal": {
      "title": "Čtečka karet",
      "description": "Výběr čtečky karet pro telematickou infrastrukturu",
      "select": "Vybrat terminál",
      "select-placeholder": "Vyberte terminál...",
      "loading": "Načítání terminálů...",
      "none-available": "Žádné dostupné terminály",
      "none-found": "Nenalezeny žádné terminály",
      "found": "Nalezeno {{count}} terminál(ů)",
      "connect-hint": "Nejprve se připojte k bridge serveru pro načtení terminálů.",
      "found-count": "Nalezené čtečky karet: {{count}}",
      "refresh": "Znovu načíst čtečky karet"
    },
    "practice": {
      "title": "Ordinace",
      "description": "Informace o vaší ordinaci",
      "name": "Název ordinace",
      "name-placeholder": "např. MUDr. Novák",
      "welcome-message": "Uvítací zpráva",
      "welcome-placeholder": "např. Vítejte v naší ordinaci",
      "scheduler-available": "Povolit Plánovač",
      "scheduler-available-description": "Umožněte pacientům rezervovat si schůzky prostřednictvím samoobslužného terminálu",
      "prescription-available": "Povolit službu předpisu",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Ponechte prázdné, aby se pozdrav zobrazil v jazyce pacienta. Vlastní text se ve všech jazycích zobrazí beze změny."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Uloženo pro všechna zařízení {{value}}",
      "never-saved-default": "Výchozí nastavení, zatím nezměněno."
    },
    "anamnesis": {
      "title": "Digitální lékařská historie",
      "description": "Po přihlášení zobrazí odkaz a QR code na vašeho poskytovatele anamnézy.",
      "enabled": "Po přihlášení ukázat odkaz na anamnézu",
      "enabled-description": "Zobrazuje odkaz a QR code na vašeho poskytovatele anamnézy po dokončení přihlášení, například Nelly.",
      "url": "Odkaz na poskytovatele lékařské anamnézy",
      "url-hint": "Odkaz je statický a identický pro všechny pacienty.",
      "preview-label": "Náhled na obrazovce dokončení",
      "preview-note": "Odkaz je statický a identický pro všechny pacienty.",
      "url-first": "Pro zapnutí nejprve zadejte platný odkaz."
    },
    "appearance": {
      "title": "Vzhled",
      "description": "Přizpůsobte uživatelské rozhraní",
      "language": "Jazyk",
      "default-kiosk-language": "Výchozí jazyk pacienta",
      "default-kiosk-language-hint": "Jazyk, ve kterém pro pacienty začínají nové relace kiosku.",
      "voice-over-volume": "Hlasitost hlasu",
      "voice-over-hint": "Ovládá hlasitost hlasového asistenta pro usnadnění přístupu.",
      "language-first": "Zobrazit výběr jazyka na začátku relace"
    },
    "security": {
      "title": "Zabezpečení",
      "description": "PIN pro přístup k nastavení",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Správa kiosku",
    "nav": {
      "general": "Obecné",
      "flows": "Funkce",
      "anamnese": "Digitální anamnéza",
      "device": "Zařízení a připojení"
    },
    "flows": {
      "title": "Funkce na terminálu"
    },
    "language": {
      "title": "Jazyk a hlasový výstup",
      "description": "Jazyk a předčítání pro pacienty na tomto zařízení."
    }
  },
  "self-service": {
    "title": "Samoobsluha",
    "step-progress": "Krok {{current}} / {{total}}",
    "flows": {
      "checkin": "Registrace",
      "scheduler": "Objednat se",
      "prescription": "Předpisy",
      "locations": "Mapa polohy",
      "emergency": "Pohotovost"
    },
    "audio-guide": {
      "on": "Zvuk zapnutý",
      "off": "Zvuk vypnutý",
      "replay": "Zopakovat pokyny",
      "replay-unavailable": "Žádné hlasové pokyny k opakování"
    },
    "language-selector": {
      "title": "Vyberte jazyk",
      "description": "Prosím vyberte preferovaný jazyk"
    },
    "settings": "Nastavení",
    "start": {
      "welcome": "Vítejte",
      "subtitle": "Prosím vyberte možnost",
      "check-in-label": "Hlavní cesta",
      "check-in-cta": "Registrace",
      "check-in-description": "Již máte objednání? Zaregistrujte se zde.",
      "check-in-hint": "Připravte si kartu",
      "scheduler-label": "Nové",
      "scheduler-cta": "Objednat se",
      "scheduler-description": "Naplánujte novou návštěvu.",
      "location-plan": "Mapa polohy",
      "location-plan-description": "Najděte cestu k ošetřovně.",
      "prescription-label": "Předpis",
      "prescription-cta": "Předpisy a objednávky",
      "prescription-description": "Prohlédněte si recepty nebo objednejte doplnění.",
      "emergency-cta": "Místní nouzový alarm",
      "emergency-description": "Zní pouze na tomto zařízení a nepřivolá pomoc.",
      "tap-to-start": "Klepnutím začněte"
    },
    "offline": {
      "banner-title": "Přihlášení je dočasně nedostupné",
      "banner-message": "Požádejte o pomoc personál recepce.",
      "emergency-available": "Místní alarm zůstává dostupný. Nepřivolá pomoc.",
      "flow-disabled": "Dočasně nedostupné"
    },
    "readability": {
      "toggle-label": "Režim čtení",
      "on": "Režim čtení",
      "off": "Režim čtení"
    },
    "reset-overlay": {
      "timeout-title": "Relace skončila",
      "timeout-subtitle": "Váš čas vypršel. Vaše data jsou v bezpečí.",
      "offline-title": "Spojení ztraceno",
      "offline-subtitle": "Spojení bylo přerušeno. Promluvte si prosím s personálem recepce.",
      "interruption-title": "Relace skončila",
      "interruption-subtitle": "Vaše relace byla bezpečně ukončena.",
      "completion-title": "děkuji!",
      "completion-subtitle": "Vaše žádost byla úspěšně dokončena.",
      "reassurance": "Vaše osobní údaje nejsou na tomto zařízení uloženy.",
      "auto-dismiss": "Návrat na start za {{seconds}} sekund...",
      "dismiss": "Přejít na začátek"
    },
    "timed-terminal": {
      "countdown": "Automatický návrat za {{seconds}} sekund",
      "countdown-outcome": "Tento terminál se automaticky vrátí na úvodní obrazovku.",
      "more-time": "Více času",
      "extended": "Čas prodloužen"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Tyto otázky nejsou dostupné ve vašem jazyce. Vyberte některý z nabízených jazyků nebo se obraťte na recepci.",
        "alternatives": "Alternativní termíny",
        "loading": "Načítání otázek…",
        "reception-fallback": "Obraťte se prosím na recepci.",
        "error-title": "Otázky se nepodařilo načíst",
        "language-unavailable-lead": "Tyto otázky nejsou ve vašem jazyce k dispozici.",
        "language-unavailable-title": "Vyberte prosím jeden z těchto jazyků",
        "language-unavailable-body": "Nebo si nechte pomoci na recepci."
      },
      "start": {
        "title": "Objednat se",
        "subtitle": "Objednejte si preferovaný termín v několika krocích",
        "welcome": "Vítejte v objednávání termínů",
        "description": "Provedeme vás procesem objednání",
        "cta": "Objednat se nyní"
      },
      "patient-id": {
        "title": "Identifikace",
        "subtitle": "Prosím identifikujte se",
        "mode-card": "S kartou",
        "mode-search": "Vyhledat",
        "mode-create": "Vytvořit nový",
        "insert-card": "Prosím vložte svou zdravotní kartu",
        "reading-card": "Čtení karty...",
        "simulate-card": "Simulovat kartu",
        "multiple-matches": "Nalezeno více pacientů. Používají se data z karty.",
        "search-placeholder": "Jméno nebo číslo pojištění...",
        "searching": "Vyhledávání...",
        "no-results": "Nenalezeny žádné výsledky",
        "first-name": "Jméno",
        "last-name": "Příjmení",
        "dob": "Datum narození",
        "insurance": "Pojištění",
        "continue": "Pokračovat",
        "creating": "Vytváření pacienta...",
        "patient-created": "Pacient byl úspěšně vytvořen!",
        "create-error": "Nepodařilo se vytvořit pacienta."
      },
      "appointment-type": {
        "title": "Vyberte typ návštěvy",
        "subtitle": "Prosím vyberte důvod vaší návštěvy",
        "loading": "Načítání typů návštěv...",
        "no-types": "Žádné dostupné typy návštěv",
        "error": "Nelze načíst typy návštěv. Prosím zkuste to znovu.",
        "no-bookable": "Tyto typy termínů nyní nelze rezervovat v kiosku. Obraťte se prosím na recepci nebo si domluvte termín telefonicky.",
        "disabled-default": "Tento termín si prosím domluvte přímo na recepci nebo telefonicky.",
        "disabled-footer": "Pouze recepce/telefon",
        "lead": "Jaký druh termínu chcete rezervovat?",
        "duration": "cca {{minutes}} minut",
        "empty-title": "Termíny zde teď nelze rezervovat",
        "none-bookable-title": "Tyto termíny zde nelze rezervovat",
        "none-bookable-body": "Zeptejte se prosím na recepci nebo nám zavolejte."
      },
      "types": {
        "general": "Obecná konzultace",
        "general-desc": "Pro obecné potíže a dotazy",
        "checkup": "Preventivní prohlídka",
        "checkup-desc": "Pravidelné zdravotní prohlídky",
        "vaccination": "Očkování",
        "vaccination-desc": "Naplánujte očkování",
        "followup": "Kontrola",
        "followup-desc": "Kontrolní návštěva",
        "prescription": "Recept",
        "prescription-desc": "Vyzvednutí receptu"
      },
      "slot-selection": {
        "title": "Vyberte termín",
        "subtitle": "Prosím vyberte dostupný termín",
        "loading": "Načítání dostupných termínů...",
        "no-slots": "Žádné dostupné termíny",
        "no-appointment-type": "Nebyl vybrán typ návštěvy",
        "error": "Nelze načíst dostupné termíny. Prosím zkuste to znovu.",
        "quick-select": "Další dostupné termíny:",
        "select-date": "Nebo vyberte datum:",
        "times-for": "{{date}}",
        "available": "Dostupné",
        "unavailable": "Žádné termíny",
        "slots": "termíny",
        "select-time-hint": "Klepněte na čas pro objednání termínu",
        "week-short": "Týd",
        "weekday-mon": "Po",
        "weekday-tue": "Út",
        "weekday-wed": "St",
        "weekday-thu": "Čt",
        "weekday-fri": "Pá",
        "weekday-sat": "So",
        "weekday-sun": "Ne",
        "period-morning": "Ráno",
        "period-midday": "Poledne",
        "period-afternoon": "Odpoledne",
        "period-evening": "Večer",
        "period-morning-short": "Ráno",
        "period-midday-short": "Pol.",
        "period-afternoon-short": "Odp.",
        "period-evening-short": "Večer",
        "period-dots-legend": "Dostupnost času",
        "filter-hint": "Filtrovat podle preferovaných časů:",
        "or-choose-below": "nebo vyberte níže",
        "no-slots-period": "Žádné sloty",
        "show-all": "Zobrazit vše",
        "free": "zdarma",
        "your-selection": "Váš výběr",
        "oclock": "hodin",
        "choose-slot": "Vyberte slot",
        "choose-day": "Vybrat den",
        "choose-day-first": "Nejprve prosím vyberte den",
        "times-heading": "Volné časy {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Žádné volné termíny: {{month}}",
        "empty-body": "Podívejte se na další měsíc nebo se zeptejte na recepci – rádi pomůžeme.",
        "next-month": "Další měsíc",
        "previous-month": "Předchozí měsíc"
      },
      "confirmation": {
        "patient-responses": "Vaše odpovědi",
        "review-loading": "Kontrola souhrnu…",
        "review-unavailable": "Shrnutí není k dispozici. Zkuste to prosím znovu nebo se zeptejte na recepci.",
        "check-booking": "Zkontrolovat rezervaci",
        "title": "Potvrdit termín",
        "subtitle": "Prosím zkontrolujte svou rezervaci",
        "patient": "Pacient",
        "datetime": "Datum a čas",
        "booking": "Rezervace...",
        "confirm": "Objednat termín",
        "heading": "Vypadá to správně?",
        "lead": "Potvrďte prosím svůj termín.",
        "appointment": "Jmenování",
        "insured-via": "Pojištěno přes",
        "description-label": "Poznámky pro ordinaci (volitelné)",
        "description-hint": "Dejte nám vědět, pokud máme při objednání nebo check-inu něco zohlednit.",
        "description-placeholder": "např. omezená pohyblivost, doprovod, důležité poznámky",
        "description-too-long": "Zkraťte prosím poznámku na maximálně 500 znaků.",
        "summary": "Shrnutí",
        "change": "Změna",
        "book-binding": "Zarezervujte si termín",
        "cancel": "Zrušit",
        "type-label": "Druh termínu",
        "datetime-value": "{{date}} v {{time}}",
        "name-label": "Jméno",
        "insurance-label": "Pojištění",
        "insurance-GKV": "Veřejné zdravotní pojištění",
        "insurance-PKV": "Soukromé zdravotní pojištění",
        "insurance-SELFPAY": "Samoplátce",
        "change-time": "Změnit termín",
        "description-free-text": "Další poznámky (nepovinné)",
        "note-wheelchair": "Používám invalidní vozík",
        "note-companion": "Přijdu s doprovodem",
        "note-interpreter": "Potřebuji tlumočníka"
      },
      "done": {
        "title": "Termín objednán!",
        "label": "Zarezervováno",
        "subtitle": "Váš termín byl úspěšně objednán.",
        "date": "Date",
        "time": "Čas",
        "booking-id": "Číslo rezervace",
        "qr-hint": "Přidat do kalendáře",
        "qr-description": "Naskenujte tento QR kód kamerou svého smartphonu pro přidání termínu do aplikace kalendáře",
        "auto-redirect": "Brzy budete přesměrováni na úvodní stránku...",
        "auto-redirect-countdown": "Návrat na začátek za {{seconds}} sekund...",
        "back-to-start": "Zpět na začátek",
        "print-button": "Vytisknout lístek s termínem",
        "print-preparing": "Připravuje se náhled tisku…",
        "print-error": "Lístek s termínem se nepodařilo otevřít. Zkuste to znovu nebo požádejte o pomoc na recepci.",
        "print-returned": "Systémový náhled tisku byl zavřen. V případě potřeby můžete požádat o další kopii.",
        "print-title": "Váš termín",
        "print-location": "Místo",
        "print-map-hint": "Otevřít místo v telefonu",
        "print-error-v2": "Lístek s termínem se nepodařilo otevřít. Zkuste to prosím znovu nebo se zeptejte na recepci."
      },
      "error": {
        "assistance-info": "Vaši rezervaci se nepodařilo potvrdit. Termín už možná je rezervován. Zeptejte se prosím na recepci.",
        "pending-title": "Rezervace nepotvrzena",
        "pending-info": "Vaši rezervaci se nepodařilo potvrdit. Termín už možná je rezervován. Zkontrolujte to prosím znovu nebo se zeptejte na recepci.",
        "title": "Objednání selhalo",
        "subtitle": "Termín nemohl být objednán.",
        "info": "Zkuste to prosím znovu nebo se zeptejte na recepci."
      },
      "phase": {
        "identify": "Přihlášení",
        "choose": "Výběr termínu",
        "confirm": "Potvrzení"
      }
    },
    "prescription": {
      "start": {
        "title": "Předpisy a objednávky",
        "subtitle": "Vložte svou kartičku pojištěnce, abyste si mohli prohlédnout recepty nebo doplnit objednávky.",
        "button": "Vložte kartu"
      },
      "card-check": {
        "loading": "Načítání čtečky karet...",
        "no-terminal": "Není nakonfigurována žádná čtečka karet",
        "no-terminal-hint": "Požádejte o pomoc personál.",
        "insert-card": "Vložte prosím svou kartu",
        "insert-card-hint": "Vložte kartu pojištěnce do čtečky karet.",
        "card-detected": "Detekována karta",
        "reading": "Čtecí karta...",
        "reading-hint": "Počkejte prosím chvíli.",
        "error": "Chyba při čtení karty",
        "retry": "Zkuste to znovu",
        "manual-lookup": "Pokračujte bez karty",
        "load-error": "Nelze načíst čtečku karet",
        "read-error": "Kartu nelze přečíst"
      },
      "patient-selection": {
        "title": "Vyberte možnost Pacient",
        "subtitle": "Bylo nalezeno více pacientů. Vyberte prosím své jméno.",
        "try-again": "Zkuste to znovu",
        "try-again-hint": "Znovu vložte kartu"
      },
      "list": {
        "title": "Vaše předpisy",
        "for-patient": "Předpisy pro {{name}}",
        "loading": "Načítání receptů...",
        "error-title": "Chyba při načítání",
        "fetch-error": "Předpisy se nepodařilo načíst",
        "back-home": "Zpět na Start",
        "done": "Hotovo"
      },
      "detail": {
        "prescription-info": "Informace o předpisech",
        "date": "Date",
        "prescriber": "Předepisující lékař",
        "comment": "Poznámka",
        "medications": "Léky",
        "form": "Formulář",
        "pack-size": "Velikost balení",
        "manufacturer": "Výrobce",
        "loading": "Načítání předpisu...",
        "fetch-error": "Podrobnosti předpisu se nepodařilo načíst",
        "back-to-list": "Zpět na seznam",
        "print": "Tisk"
      },
      "types": {
        "public": "Veřejný předpis",
        "private": "Soukromý předpis",
        "long-term": "Dlouhodobý předpis",
        "btm": "Narkotický předpis",
        "g": "Zelený předpis",
        "t": "T-předpis"
      },
      "no-patient": {
        "title": "Pacient nenalezen",
        "subtitle": "Pro tuto kartu se bohužel nenašel žádný pacient. Požádejte o pomoc personál.",
        "try-again": "Zkuste to znovu",
        "back-home": "Zpět na začátek",
        "title-v2": "Nenalezeny žádné odpovídající údaje",
        "subtitle-v2": "Nepodařilo se vás najít. Zkuste to prosím znovu nebo se zeptejte na recepci."
      },
      "done": {
        "title": "Děkuji",
        "subtitle": "Teď si můžete sednout. Máte-li dotazy, kontaktujte prosím personál.",
        "no-prescriptions-title": "Žádné předpisy v evidenci",
        "no-prescriptions-subtitle": "Nenašli jsme pro vás žádné aktivní recepty. Pokud jste to očekávali, kontaktujte prosím personál recepce.",
        "error-title": "Došlo k chybě",
        "error-subtitle": "Další pomoc vám poskytne personál.",
        "auto-redirect": "Automatické přesměrování za {{seconds}} sekund",
        "finish": "Zpět na Start"
      },
      "hub": {
        "title": "Vaše předpisy",
        "for-patient": "Předpisy pro {{name}}",
        "loading": "Načítání receptů...",
        "error-title": "Chyba při načítání",
        "fetch-error": "Předpisy se nepodařilo načíst",
        "back-home": "Zpět na Start",
        "done": "Hotovo",
        "order-button": "Objednávka předpisu",
        "existing-prescriptions": "Vaše aktuální recepty",
        "no-prescriptions": "Nebyly nalezeny žádné aktivní recepty."
      },
      "patient-lookup": {
        "title": "Najděte pacienta",
        "subtitle": "Zadejte své jméno a datum narození.",
        "last-name": "Příjmení",
        "first-name": "Křestní jméno",
        "date-of-birth": "Datum narození",
        "lastname": "Příjmení",
        "lastname-placeholder": "Vaše příjmení",
        "firstname": "Křestní jméno",
        "firstname-placeholder": "Vaše křestní jméno",
        "dob": "Datum narození",
        "search": "Hledat",
        "searching": "Hledání...",
        "search-error": "Chyba hledání: {{message}}",
        "no-match": "Nebyl nalezen žádný pacient. Zkontrolujte prosím své údaje.",
        "error": "Chyba vyhledávání. Zkuste to prosím znovu.",
        "found": "Pacient nalezen",
        "confirm": "Potvrďte",
        "ambiguous": "Více zápasů",
        "ambiguous-hint-firstname": "Pro upřesnění hledání zadejte také své křestní jméno.",
        "ambiguous-hint-additional": "Zkontrolujte prosím své údaje nebo kontaktujte personál.",
        "not-found": "Pacient nenalezen",
        "not-found-hint": "Žádný pacient s těmito detaily nebyl nalezen.",
        "not-found-action": "Zkuste to znovu"
      },
      "manual-identification": {
        "unverified": "Vaše totožnost nebyla potvrzena kartou zdravotního pojištění. Ordinace před zpracováním ověří vaše údaje a žádost."
      },
      "medication-selection": {
        "title": "Vyžádejte si předpis",
        "subtitle": "Ordinace posoudí vaši žádost. Po schválení bude eRx připravený ve vaší aplikaci e-prescription.",
        "back": "Zpět",
        "submit": "Pokračujte v kontrole",
        "reason-title": "Proč potřebujete předpis?",
        "reason-hint": "Pomáhá ordinaci posoudit vaši žádost.",
        "reason-validation": "Vyberte prosím důvod.",
        "reason-schmerzen": "Bolest",
        "reason-entzuendung": "Zánět",
        "reason-nachsorge": "Po operaci/zákroku",
        "reason-allergie": "Alergie / reakce",
        "reason-chronisch": "Chronický stav",
        "reason-anderes": "Něco jiného",
        "medications-title": "Jaké léky?",
        "request-hint": "Popište, co potřebujete, nebo pojmenujte předchozí předpis, který chcete obnovit.",
        "request-placeholder": "např. Ibuprofen 600 mg, stejně jako minule",
        "request-validation": "Popište prosím, jaké léky potřebujete.",
        "history-title": "Předchozí recepty",
        "history-hint": "Přidejte záznam pro předvyplnění vašeho požadavku.",
        "history-loading": "Načítání předchozích receptů...",
        "history-error": "Předchozí recepty nelze načíst.",
        "history-add": "Přidat",
        "history-added": "Přidáno",
        "history-date": "Poslední: {{date}}",
        "history-request-line": "Obnovit: {{medicationName}}",
        "urgency-title": "Jak je to naléhavé?",
        "urgency-hint": "Pomáhá ordinaci určit prioritu.",
        "urgency-soon": "Naléhavé",
        "urgency-soon-meta": "Co nejdříve",
        "urgency-tomorrow": "brzy",
        "urgency-tomorrow-meta": "V příštích dnech",
        "urgency-week": "Tento týden",
        "urgency-week-meta": "Žádný časový tlak",
        "lead": "Ordinace vaši žádost posoudí. Po schválení najdete svůj e-recept v aplikaci pro e-recepty nebo na kartičce pojištěnce.",
        "history-hint-v2": "Klepněte na dřívější recept a převezměte ho.",
        "history-retry": "Načíst znovu"
      },
      "request-review": {
        "title": "Zkontrolujte objednávku",
        "subtitle": "Zkontrolujte prosím svou žádost o předpis.",
        "request-label": "Požadovaný lék",
        "selected-medications": "Vybrané léky",
        "free-text-medications": "Doplňkové léky",
        "freetext-label": "Jiné",
        "quarterly-warning": "Vaše kartička pojištěnce nebyla v tomto čtvrtletí načtena. Ordinace vás může kontaktovat.",
        "egk-warning": "Vaše kartička pojištěnce nebyla v tomto čtvrtletí načtena. Ordinace vás může kontaktovat.",
        "submit": "Odeslat",
        "submitting": "Odesílání...",
        "submit-error": "Žádost se nepodařilo odeslat. Zkuste to prosím znovu.",
        "back": "Zpět",
        "reason-label": "Důvod",
        "urgency-label": "Naléhavost",
        "completion-email-choice": "Chci obdržet e-mail, jakmile ordinace zpracuje mou žádost.",
        "completion-email-label": "E-mailová adresa",
        "completion-email-placeholder": "jmeno@priklad.cz",
        "completion-email-hint": "Pouze pro tuto jednorázovou zprávu. Adresa se neukládá do kmenových údajů.",
        "completion-email-invalid": "Zadejte platnou e-mailovou adresu.",
        "egk-proof-required": "Žádosti o recept jsou možné pouze po úspěšném načtení karty pojištěnce. Obraťte se prosím na personál.",
        "title-v2": "Zkontrolovat žádost",
        "completion-email-hint-v2": "Adresa se použije jen pro tuto jednu zprávu."
      },
      "confirmation": {
        "title": "Žádost odeslána",
        "subtitle": "Vaše žádost o předpis byla úspěšně odeslána.",
        "success-title": "Žádost odeslána",
        "success-subtitle": "Vaše žádost o předpis byla úspěšně odeslána.",
        "estimated-time": "Váš předpis bude připraven přibližně za {{time}}.",
        "info": "Recept si můžete vyzvednout v lékárně pomocí kartičky pojištěnce nebo aplikace eRezept.",
        "auto-redirect": "Automatické přesměrování za {{seconds}} sekund",
        "back-to-start": "Zpět na Start",
        "handling-label": "Handled by the practice",
        "next-steps": "Ordinace vaši žádost posoudí. Po schválení můžete e-recept vyzvednout v lékárně s kartičkou pojištěnce nebo v aplikaci pro e-recepty."
      },
      "phase": {
        "identify": "Přihlášení",
        "request": "Žádost",
        "review": "Kontrola"
      }
    },
    "check-in": {
      "flow-label": "Odbavení",
      "has-appointment": {
        "eyebrow": "Jmenování",
        "title": "Máte objednání?",
        "subtitle": "Prosím vyberte možnost",
        "yes-label": "Ano",
        "yes": "Ano, mám objednání",
        "yes-description": "Chci se zaregistrovat na svůj termín.",
        "yes-hint": "Nejrychlejší cesta",
        "unsure-label": "Možná",
        "unsure": "Nejsem si jistý",
        "unsure-description": "Zkontrolujeme to za vás.",
        "unsure-hint": "My tě vyhledáme",
        "no-label": "Ne",
        "no": "Ne, bez objednání",
        "no-description": "Nemám objednání.",
        "no-hint": "Walk-in"
      },
      "card-check": {
        "eyebrow": "Karta pojištění",
        "title": "Přečíst zdravotní kartu",
        "subtitle": "Prosím vložte svou zdravotní kartu do čtečky",
        "insert-title": "Vložte kartu zdravotního pojištění do čtečky.",
        "insert-detail": "Vaše údaje čteme automaticky – nemusíte dělat nic jiného.",
        "other-ways": "Jiné způsoby",
        "no-card-hint": "Pokud právě u sebe nemáte kartu.",
        "pkv-hint": "Použijte QR code s aplikací pojištění.",
        "loading": "Načítání nastavení...",
        "no-terminal": "Není nakonfigurována žádná čtečka karet. Prosím kontaktujte personál.",
        "checking": "Kontrola karet...",
        "insert-prompt": "Prosím vložte kartu...",
        "card-detected": "Karta detekována! Připravena ke čtení.",
        "read-card": "Přečíst kartu",
        "simulate-insert": "Simulovat kartu",
        "reading": "Čtení karty...",
        "error": "Nelze přečíst kartu. Prosím zkuste to znovu.",
        "read-error": "Chyba při čtení dat z karty. Prosím zkuste to znovu.",
        "settings-error": "Nelze načíst nastavení. Prosím zkuste to znovu.",
        "no-card-prompt": "Nemáte kartu u sebe?",
        "no-card-action": "Ruční vyhledávání",
        "connection-warning": "Problémy s připojením čtečky karet. Čekejte prosím...",
        "pkv-prompt": "Soukromé pojištění? Online Check-in",
        "pkv-instruction": "Naskenujte tento QR code pomocí své soukromé aplikace zdravotního pojištění a přeneste svá data digitálně.",
        "pkv-continue": "Pokračujte ruční registrací",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Zkuste to prosím znovu nebo se přihlaste bez karty. Recepce vám ráda pomůže.",
        "title-pkv": "Přihlášení přes aplikaci",
        "title-reading": "Vaše karta se načítá …",
        "title-unreadable": "Kartu se nepodařilo načíst",
        "title-no-terminal": "Přihlášení bez karty",
        "no-terminal-body": "Čtečka karet teď není k dispozici. Přihlaste se prosím bez karty nebo se obraťte na recepci.",
        "reading-detail": "Nechte prosím kartu ve čtečce. Potrvá to jen chvilku.",
        "other-ways-title": "Další možnosti",
        "no-card-title": "Přihlásit se bez karty",
        "pkv-prompt-title": "Soukromě pojištěni?",
        "pkv-prompt-hint": "Přihlášení přes aplikaci vašeho soukromého zdravotního pojištění",
        "pkv-close": "Přece jen s kartou",
        "pkv-instruction-app": "Otevřete aplikaci svého soukromého zdravotního pojištění a naskenujte tento kód. Vaše údaje pak přijdou přímo k nám."
      },
      "patient-selection": {
        "title": "Vyberte pacienta",
        "subtitle": "Nalezeno více pacientů. Prosím vyberte sebe.",
        "firstname-label": "Vaše křestní jméno",
        "firstname-placeholder": "Zadejte křestní jméno...",
        "confirm-button": "Potvrďte",
        "no-match": "Nebyl nalezen žádný odpovídající pacient. Obraťte se prosím na recepci pro pomoc.",
        "still-ambiguous": "Zbývá několik zápasů. Obraťte se prosím na recepci pro pomoc.",
        "select-error": "Nepodařilo se identifikovat pacienta. Zkuste to prosím znovu.",
        "staff-assist": "Jděte na recepci",
        "title-v2": "Krátký dotaz",
        "subtitle-v2": "Pro jistotu zadejte prosím své křestní jméno.",
        "no-match-v2": "S tímto křestním jménem jsme vás nenašli. Zkontrolujte pravopis nebo se obraťte na recepci.",
        "still-ambiguous-v2": "Zatím jsme vás nemohli jednoznačně najít. Obraťte se prosím na recepci.",
        "select-error-v2": "To se bohužel nepovedlo. Zkuste to prosím znovu."
      },
      "card-checkin": {
        "title": "Potvrdit registraci",
        "subtitle": "Vaše data byla úspěšně přečtena.",
        "confirm": "Potvrdit registraci"
      },
      "register-from-card": {
        "title": "Nová registrace",
        "subtitle": "Ještě nejste v našem systému. Chcete se zaregistrovat?",
        "card-data": "Údaje o kartě",
        "create": "Zaregistrovat se",
        "create-error": "Registrace se nezdařila. Zkuste to znovu nebo požádejte o pomoc personál.",
        "staff-assist": "Zavolejte personál",
        "no-card-data-title": "Žádná data karty",
        "no-card-data": "Nelze číst data z vaší karty.",
        "insurance-verified": "Pojištění ověřeno: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Vaše údaje z karty",
        "subtitle-v2": "Zkontrolujte prosím své údaje. Pokud něco nesedí, klepněte na „Změnit“.",
        "create-v2": "Potvrdit údaje",
        "create-error-v2": "Přihlášení se bohužel nepovedlo. Zkuste to znovu nebo se obraťte na recepci.",
        "insurer-missing-v2": "Na vaší kartě chybí údaj o zdravotní pojišťovně. Obraťte se prosím na recepci.",
        "edit": "Změnit",
        "name": "Jméno",
        "insurer": "Zdravotní pojišťovna"
      },
      "patient-lookup": {
        "title": "Vyhledat pacienta",
        "subtitle": "Prosím zadejte své jméno nebo číslo pojištění.",
        "lastname": "příjmení",
        "lastname-placeholder": "Vaše příjmení",
        "dob": "Datum narození",
        "firstname": "Křestní jméno",
        "firstname-placeholder": "Vaše křestní jméno",
        "search": "Hledat",
        "searching": "Hledání...",
        "search-placeholder": "Jméno nebo číslo pojištění...",
        "results-placeholder": "Výsledky vyhledávání se objeví zde",
        "found": "Pacient nalezen!",
        "confirm-identity": "Potvrďte prosím, že jste zobrazený pacient.",
        "confirm-button": "To jsem já",
        "ambiguous-firstname": "Bylo nalezeno více pacientů. Zadejte své křestní jméno.",
        "ambiguous-additional": "Bylo nalezeno více pacientů. Kontaktujte prosím personál.",
        "disambiguation-hint": "To nám pomůže vás jasně identifikovat.",
        "not-found": "Žádný pacient s těmito detaily nebyl nalezen.",
        "error": "Chyba hledání: {{message}}",
        "staff-assist": "Zavolejte personál",
        "not-found-prompt": "Nenalezeno?",
        "register-new": "Zaregistrovat nového",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Přihlášení bez karty",
        "subtitle-firstname": "Zadejte prosím také své křestní jméno.",
        "ambiguous-firstname-v2": "Toto příjmení má více osob. Zadejte prosím také své křestní jméno.",
        "search-again": "Hledat znovu",
        "found-v2": "Našli jsme vás",
        "found-confirm": "Potvrďte prosím tlačítkem „To jsem já“.",
        "not-found-title": "Nenašli jsme vás",
        "not-found-check": "Zkontrolujte prosím pravopis a datum narození. Recepce vám ráda pomůže.",
        "not-found-reception": "Zkontrolujte prosím pravopis a datum narození nebo se obraťte na recepci.",
        "ambiguous-additional-v2": "Nemohli jsme vás jednoznačně najít. Obraťte se prosím na recepci.",
        "error-v2": "Hledání se teď nepovedlo. Zkuste to prosím znovu."
      },
      "checking-in": {
        "title": "Moment – odbavujeme vás.",
        "subtitle": "Přidáváme vás do fronty na ošetření a informujeme tým.",
        "step-insurance": "Pojištění zkontrolováno",
        "step-appointment": "Jmenování potvrzeno",
        "step-waitlist": "Přidání na čekací listinu",
        "error": "Přihlášení se nezdařilo. Zkuste to prosím znovu.",
        "continue": "Přesto pokračujte",
        "title-v2": "Chvilku strpení",
        "loading": "Přihlašujeme vás …",
        "subtitle-v2": "Zapisujeme vás do čekací listiny a dáváme vědět týmu.",
        "error-title": "To se bohužel nepovedlo",
        "error-v2": "Vaše přihlášení nebylo možné dokončit.",
        "error-body": "Zkuste to prosím znovu. Pokud to opět nepůjde, pomůže vám recepce."
      },
      "appointment-selection": {
        "title": "Vyberte schůzku",
        "subtitle": "Dnes máte několik schůzek. Vyberte prosím jednu.",
        "checking-in": "Přihlašování...",
        "time": "{{time}}",
        "error-v2": "Přihlášení k tomuto termínu se nepovedlo. Zkuste to znovu nebo se obraťte na recepci."
      },
      "no-appointment": {
        "title": "Nebyla nalezena žádná schůzka",
        "subtitle": "Dnes jsme pro vás nemohli najít schůzku. Rezervujte si prosím pravidelný termín.",
        "book-appointment": "Zarezervujte si termín",
        "book-appointment-description": "Zarezervujte si nový termín prostřednictvím běžného plánovače.",
        "staff-assist": "Zavolejte personál",
        "staff-assist-description": "Potřebuji pomoc.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Dnes jsme pro vás nenašli žádný termín.",
        "book-v2": "Domluvit nový termín",
        "book-v2-description": "Vyberte si nyní volný termín.",
        "have-appointment": "Mám termín",
        "have-appointment-description": "Recepce vám ráda pomůže.",
        "unavailable-title": "Termíny si prosím domluvte na recepci",
        "subtitle-unavailable": "Dnes jsme pro vás nenašli žádný termín. Obraťte se prosím na recepci."
      },
      "staff-assist": {
        "title": "Zaměstnanci informováni",
        "subtitle": "Pracovník vám brzy pomůže.",
        "message": "Počkejte prosím zde. Zanedlouho u vás bude zaměstnanec.",
        "start-over": "Zpět na začátek",
        "auto-redirect": "Návrat na start za {{seconds}} sekund..."
      },
      "eeb-prompt": {
        "title": "Ověřit pojištění",
        "title-failed": "Ověření selhalo",
        "subtitle": "Jak chcete ověřit své pojištění?",
        "subtitle-failed": "Naskenujte QR kód svou pojišťovací aplikací pro žádost o ověření.",
        "verify-card": "Ověřit elektronicky",
        "verify-card-description": "Odeslat žádost vaší pojišťovně.",
        "select-insurer": "Vybrat pojišťovnu",
        "select-insurer-description": "Ruční výběr vaší pojišťovny.",
        "skip": "Přeskočit",
        "eyebrow-chip": "Alternativní",
        "eyebrow": "Přihlášení · doklad o pojištění (eEB)",
        "recommended": "Doporučeno",
        "qr-title": "Skenujte pomocí aplikace pojištění",
        "qr-description": "Otevřete aplikaci zdravotního pojištění a naskenujte kód – eEB je zaslán přímo nám.",
        "qr-address-label": "Odeslat na",
        "title-app": "Potvrzení přes aplikaci",
        "subtitle-app": "Vaše pojišťovna nám může potvrzení poslat i přímo. Až budete hotovi, klepněte na „Dále“."
      },
      "quarterly-check": {
        "title": "Kontrola pojištění",
        "checking": "Kontrolujeme vaše aktuální ověření pojištění...",
        "error": "Kontrola nemohla být provedena.",
        "title-v2": "Vaše pojištění",
        "checking-v2": "Kontrolujeme vaše pojištění – chvilku strpení.",
        "error-body": "Vaše přihlášení je hotové. Pojištění s vámi vyřeší recepce."
      },
      "insurer-prefilled": {
        "title": "Vaše zdravotní pojištění",
        "subtitle": "Prosím potvrďte své pojištění pro toto čtvrtletí.",
        "your-insurance": "Vaše pojištění",
        "last-read": "Naposledy zkontrolováno {{date}}",
        "quarterly-notice": "Pro účely fakturace potřebujeme aktuální doklad o pojištění pro toto čtvrtletí.",
        "confirm-button": "Ano, toto je moje pojištění",
        "change-button": "Mám jiné pojištění",
        "contact-title": "Vyžádejte si elektronický doklad o krytí",
        "contact-description": "Zavolejte své pojišťovně a požádejte o elektronický doklad o pojištění pro:",
        "contact-patient": "Pacient",
        "contact-kim-address": "KIM adresa ordinace",
        "contact-phone": "Phone",
        "question": "Je toto vaše zdravotní pojišťovna?",
        "quarterly-notice-v2": "Jednou za čtvrtletí potřebujeme potvrzení od vaší pojišťovny."
      },
      "insurer-search": {
        "title": "Vyberte zdravotní pojištění",
        "subtitle": "Prosím vyhledejte a vyberte své povinné zdravotní pojištění.",
        "placeholder": "Vyhledat pojištění...",
        "hint": "Zadejte alespoň 2 znaky pro vyhledávání.",
        "no-results": "Nenalezeno žádné pojištění.",
        "no-results-hint": "Zkontrolujte pravopis nebo zkuste jiné vyhledávání.",
        "label": "Název vaší zdravotní pojišťovny",
        "search-error-v2": "Hledání se teď nepovedlo. Zkuste to prosím znovu.",
        "app-alternative": "Raději přes aplikaci své pojišťovny?"
      },
      "insurer-contact": {
        "title": "Vyžádejte si doklad o pojištění",
        "subtitle": "Vyberte prosím jednu z následujících možností.",
        "or": "nebo",
        "option-eeb-title": "Žádost elektronicky",
        "option-eeb-description": "Pokud nastal zákonný výjimečný případ, můžete po svém souhlasu předat žádost týmu ordinace.",
        "option-qr-title": "Skenujte pomocí aplikace",
        "option-qr-description": "Naskenujte QR code pomocí své pojišťovací aplikace.",
        "option-call-title": "Zavolej si",
        "option-call-description": "Zavolejte své pojišťovně a požádejte o eEB pro tuto ordinaci:",
        "phone": "Phone",
        "phone-not-available": "Telefonní číslo na kartě pojištěnce",
        "patient-name": "Pacient",
        "practice-kim": "KIM adresa ordinace",
        "help-notice": "V případě problémů navštivte recepci.",
        "submit-eeb-button": "Požádejte nyní",
        "contacted-button": "zavolal jsem",
        "contacted-button-countdown": "Čas na váš hovor ({{seconds}}s)",
        "go-to-counter-button": "Jděte na recepci",
        "qr-continue-button": "Naskenoval jsem",
        "qr-continue-button-countdown": "Čas na skenování ({{seconds}}s)",
        "title-v2": "Potvrzení od vaší zdravotní pojišťovny",
        "subtitle-v2": "Nejjednodušší je to přes aplikaci vaší pojišťovny.",
        "subtitle-no-app": "Vyberte prosím, jak nám má pojišťovna potvrzení poslat.",
        "option-eeb-description-v2": "Požádáme vaši pojišťovnu za vás. K tomu potřebujeme váš souhlas.",
        "call-instruction": "Zavolejte své pojišťovně a požádejte o zaslání potvrzení do naší ordinace.",
        "call-instruction-practice": "Zavolejte své pojišťovně a požádejte o zaslání potvrzení do ordinace {{practice}}.",
        "done-button": "Hotovo – dále",
        "done-button-countdown": "Hotovo – dále (ještě {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Souhlas",
        "subtitle": "Potřebujeme váš souhlas pro elektronické ověření pojištění.",
        "insurance": "Vaše pojištění",
        "consent-title": "Souhlas s elektronickým ověřením pojištění (eEB)",
        "consent-text": "Beru na vědomí, že moje zdravotní pojišťovna předá moje pojistné údaje (např. jméno, datum narození, číslo pojištěnce) prostřednictvím zabezpečené komunikační služby KIM ordinaci {{practiceName}} jako doklad o pojištění. Souhlasím s tímto předáním. Jsem si vědom/a, že tento souhlas mohu kdykoli odvolat, aniž by to ovlivnilo mou léčbu.",
        "withdrawal-notice": "Tento souhlas můžete kdykoli odvolat.",
        "agree-button": "Souhlasím",
        "decline-button": "Zrušit",
        "treatment-notice": "Vaše léčení není tímto souhlasem ovlivněno.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Potvrzení od vaší zdravotní pojišťovny",
        "summary": "Vaše pojišťovna nám pošle potvrzení přímo. K tomu potřebujeme váš souhlas.",
        "confirm-first": "Nejdříve prosím potvrďte prohlášení."
      },
      "qr-code": {
        "title": "Naskenovat pojišťovací aplikací",
        "instruction-1": "Otevřete svou pojišťovací aplikaci a naskenujte tento QR kód.",
        "instruction-2": "Ordinace poté automaticky obdrží ověření vašeho pojištění.",
        "practice": "Ordinace: {{name}}",
        "alternative-hint": "Alternativa: Použijte svou pojišťovací aplikaci",
        "instruction-app": "Otevřete aplikaci své zdravotní pojišťovny a naskenujte tento kód. Potvrzení pak přijde přímo k nám.",
        "staff-line": "Pro tým ordinace: {{address}}",
        "staff-line-practice": "Pro tým ordinace: {{name}} · {{address}}",
        "alternative-app": "Potvrzení si můžete vyžádat i přes aplikaci své pojišťovny: otevřete aplikaci a naskenujte tento kód."
      },
      "register-basics": {
        "title": "Osobní údaje",
        "subtitle": "Prosím zadejte své údaje.",
        "family-name": "Příjmení",
        "given-name": "Jméno",
        "dob": "Datum narození",
        "gender": "Pohlaví",
        "insurance-type": "Typ pojištění",
        "insurer-name": "Název vaší pojišťovny",
        "insurer-name-placeholder": "např. Debeka, DKV, Allianz...",
        "gender-required": "Vyberte prosím jednu možnost."
      },
      "register-insurer": {
        "title": "Zdravotní pojištění",
        "subtitle": "Prosím vyberte své zdravotní pojištění.",
        "search-placeholder": "Vyhledat pojištění..."
      },
      "register-details": {
        "title": "Souhrn",
        "subtitle": "Prosím zkontrolujte své údaje.",
        "create": "Dokončit registraci",
        "missing-data": "Vyplňte prosím všechna povinná pole.",
        "create-error": "Registrace se nezdařila. Zkuste to prosím znovu.",
        "policy-number": "Číslo pojistné smlouvy (volitelné)",
        "policy-number-placeholder": "Číslo vaší pojistky",
        "create-v2": "Dokončit přihlášení",
        "policy-number-hint": "Číslo najdete na kartě svého pojištění."
      },
      "diff-review": {
        "eyebrow-chip": "Recenze",
        "eyebrow": "Check-in · údaje o kartě",
        "title": "Porovnání dat",
        "subtitle": "Byly nalezeny rozdíly mezi daty z vaší karty a našimi záznamy.",
        "col-current": "Aktuální rekord",
        "col-new": "Nové z karty",
        "new-badge": "nové",
        "field-fallback": "pole",
        "note": "Aktualizované údaje nám pomáhají správně fakturovat a kontaktovat vás v případě nouze.",
        "comparison-placeholder": "Porovnání bude zobrazeno zde",
        "confirm": "Potvrdit změny",
        "apply-error": "Data nelze použít. Zkuste to prosím znovu.",
        "retry": "Zkuste to znovu",
        "skip": "Přesto pokračujte",
        "no-changes": "Nenalezeny žádné změny",
        "title-v2": "Vaše údaje se změnily",
        "subtitle-v2": "Na vaší kartě jsou novější údaje. Máme je převzít?",
        "confirm-v2": "Převzít a přihlásit",
        "keep": "Přihlásit bez změny",
        "col-current-v2": "Dosud",
        "col-new-v2": "Nové z karty",
        "value-yes": "Ano",
        "value-no": "Ne"
      },
      "insurance-selection": {
        "title": "Typ pojištění",
        "subtitle": "Prosím vyberte svůj typ pojištění.",
        "gkv": "Zákonně pojištěný",
        "gkv-description": "Člen povinného zdravotního pojištění.",
        "pkv": "Soukromé nebo samoplatba",
        "pkv-description": "Soukromě pojištěný nebo samoplatba.",
        "pkv-description-v2": "Soukromé zdravotní pojištění, nebo platíte sami."
      },
      "eeb-request": {
        "title": "Žádost zaznamenána",
        "subtitle": "Můžete dokončit odbavení. Odpověď od {{insurer}} dorazí do ordinace později.",
        "verifying": "Vaše žádost byla přijata k okamžitému zpracování.",
        "success": "Vaše žádost byla bezpečně předána týmu ordinace.",
        "error": "Potvrzení žádosti není k dispozici.",
        "try-alternative": "Alternativní metoda",
        "kim-load-error": "KIM adresu ordinace se nepodařilo načíst.",
        "kim-label": "Ordinace · KIM",
        "non-blocking-note": "Toto ještě nepotvrzuje doručení vaší zdravotní pojišťovně ani váš status pojištění.",
        "auto-continue": "Za {{seconds}} sekund se automaticky pokračuje.",
        "unavailable-title": "To se bohužel nepovedlo",
        "unavailable-v2": "Vaši žádost u zdravotní pojišťovny se nepodařilo zaznamenat.",
        "unavailable-body": "Potvrzení si můžete nechat poslat přes aplikaci pojišťovny nebo to vyřešit na recepci.",
        "use-app": "Přes aplikaci",
        "at-reception": "Vyřešit na recepci"
      },
      "self-pay": {
        "title": "Samoplatba",
        "subtitle": "Budete ošetřeni jako pacient se samoplatbou.",
        "info": "Prosím vezměte na vědomí, že ponesete odpovědnost za náklady léčení.",
        "confirm": "Rozumím",
        "title-v2": "Platíte sami",
        "subtitle-v2": "Ošetření si platíte sami.",
        "insured-after-all": "Přece jen pojištěn"
      },
      "done": {
        "title": "Hotovo!",
        "subtitle": "Vaše registrace je dokončena.",
        "finish": "Dokončit",
        "done-label": "Hotovo",
        "error-label": "Všimněte si",
        "eyebrow": "Přihlášení · dokončeno",
        "queue-label": "Čekárna",
        "queue-title": "Posaďte se prosím",
        "queue-meta": "Zavoláme Vám osobně.",
        "success-title": "Registrace úspěšná!",
        "success-subtitle": "Prosím posaďte se v čekárně. Budete zavoláni.",
        "auto-redirect": "Brzy budete přesměrováni na úvodní stránku...",
        "auto-redirect-countdown": "Návrat na start za {{seconds}} sekund...",
        "card-expired-title": "Karta vypršela",
        "card-expired-subtitle": "Vaše zdravotní karta vypršela.",
        "card-expired-info": "Prosím kontaktujte personál pro pomoc.",
        "back-to-start": "Zpět na začátek",
        "anamnesis-title": "Vyplňte formulář anamnézy",
        "anamnesis-description": "Naskenujte QR code a vyplňte formulář své anamnézy pohodlně na svém smartphonu.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Jste přihlášeni",
        "card-expired-info-v2": "Obraťte se prosím na recepci."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Zkontrolujte své údaje",
          "balance-prefix": "Při uložení:",
          "balance-direct-v2": "Uloženo hned: {{count}}",
          "balance-reception-v2": "Zkontroluje recepce: {{count}}",
          "chip-reception-v2": "Změny kontroluje naše recepce",
          "chip-changed": "Změněno: {{count}}",
          "remove": "Odebrat",
          "example-email": "např. jmeno@priklad.cz",
          "example-phone": "např. 601 234 567",
          "intro-v2": "Vaše přihlášení je hotové. Jsou tyto údaje stále správné? Kontrola je dobrovolná.",
          "auto-hide": "Zobrazené hodnoty se po chvíli opět skryjí."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Tento údaj jsme předali recepci.",
          "banner-done-v2": "Děkujeme! Vaše údaje jsme obdrželi.",
          "footer-v2": "Všechny ostatní údaje zůstávají beze změny."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Z důvodu ochrany údajů jsme zobrazení zavřeli. Vaše přihlášení je přesto hotové. Změny můžete kdykoli sdělit na recepci."
        }
      },
      "progress": {
        "identify": "Přihlášení",
        "insurance": "Pojištění",
        "done": "Hotovo"
      },
      "dob-format-hint": "Například 01.10.1980",
      "dob-required": "Zadejte prosím datum narození.",
      "insurance-label": {
        "GKV": "Zákonné pojištění",
        "PKV": "Soukromé pojištění",
        "SELFPAY": "Samoplátce"
      }
    },
    "emergency": {
      "title": "Akutní pohotovost!",
      "label": "Pohotovost",
      "subtitle": "Tento alarm je slyšet pouze místně a nepřivolal pomoc. Při akutním nebo potenciálně život ohrožujícím stavu volejte 112.",
      "call-emergency": "Zavolejte na tísňovou linku (112)",
      "stop-sound": "Zastavit zvuk",
      "play-sound": "Přehrát zvuk",
      "back-to-start": "Zpět na začátek",
      "headline": "Okamžitě se obraťte na personál na recepci. Při ohrožení života volejte 112."
    },
    "help-reception": "Pomoc na recepci",
    "help-reception-toast": "Kontaktujte prosím recepci. Rádi vám pomůžeme.",
    "language-entry": {
      "title": "Vyberte jazyk"
    },
    "loading": "Načítání…",
    "step-progress-label": "Průběh",
    "step-progress-phase": "Oddíl {{current}} z {{total}}: {{phase}}",
    "step-progress-substep": "Část {{current}} z {{total}}",
    "step-progress-complete": "Dokončeno",
    "identification": {
      "title": "Kdo jste?",
      "lead": "Nejrychleji to jde s kartičkou pojištěnce. Můžete také hledat podle jména.",
      "lead-card-only": "Vložte prosím kartičku pojištěnce do čtečky karet.",
      "mode-label": "Jak se chcete přihlásit?",
      "mode-card": "Kartou",
      "mode-search": "Hledat podle jména",
      "mode-create": "Nový pacient",
      "card": {
        "loading": "Připravuje se čtečka karet …",
        "checking": "Kontroluje se čtečka karet …",
        "insert-title": "Vložte prosím kartičku pojištěnce do čtečky karet.",
        "insert-detail": "Vaše údaje načteme automaticky.",
        "detected": "Karta rozpoznána",
        "read": "Načíst kartu",
        "reading": "Karta se načítá …",
        "reading-hint": "Nechte prosím kartu vloženou.",
        "no-terminal-title": "Čtečka karet není dostupná",
        "help-with-search": "Vyhledejte se prosím podle jména nebo se zeptejte na recepci.",
        "help-reception": "Zeptejte se prosím na recepci – rádi pomůžeme.",
        "unreadable-title": "Karta rozpoznána, ale nečitelná",
        "error-title": "Kartu se nepodařilo načíst",
        "not-unique": "Nepodařilo se vás jednoznačně přiřadit ke kartě. Vyhledejte se prosím podle jména nebo se zeptejte na recepci.",
        "no-match": "K této kartě jsme nenašli žádné údaje. Vyhledejte se prosím podle jména nebo se zeptejte na recepci.",
        "without-card": "Pokračovat bez karty"
      },
      "lookup": {
        "lead": "Zadejte prosím své příjmení a datum narození.",
        "first-name": "Jméno",
        "last-name": "Příjmení",
        "dob": "Datum narození",
        "dob-hint": "Formát: DD.MM.RRRR",
        "search": "Hledat",
        "confirm": "Ano, to jsem já",
        "found-title": "Našli jsme vás",
        "found-body": "Potvrďte prosím, že jde o vás.",
        "first-name-needed-title": "Doplňte prosím své jméno",
        "first-name-needed-body": "Abychom vás jednoznačně našli. Potom klepněte na „Hledat“.",
        "ambiguous-title": "Nepodařilo se vás jednoznačně najít",
        "ambiguous-body": "Zeptejte se prosím na recepci – rádi pomůžeme.",
        "not-found-title": "Nenalezeny žádné odpovídající údaje",
        "not-found-body": "Zkontrolujte prosím zadané údaje.",
        "error-title": "Hledání teď není možné",
        "error-body": "Zkuste to prosím znovu nebo se zeptejte na recepci."
      },
      "create": {
        "insurance-question": "Jak jste pojištěni?",
        "insurance-required": "Vyberte prosím, jak jste pojištěni.",
        "error-title": "Vaše údaje se nepodařilo uložit",
        "error-body": "Zkuste to prosím znovu nebo se zeptejte na recepci."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Nejprve odemkněte",
      "subtitle": "FrontDesk+ musí být aktivován ve vašem cvičném softwaru.",
      "step1": "Objednávejte v SolStore (nebo za vás objednává váš partner Doc-Cirrus).",
      "step2": "Po aktivaci aktivujte v inSuite pod „inSuite Sols“ (práva správce).",
      "step3": "Otevřete administraci Bridge → „Přidat zařízení“.",
      "cta": "Vše hotovo - pokračujte"
    },
    "welcome": {
      "title": "Přidejte toto zařízení do praxe",
      "scan": "Vyfoťte kód",
      "prepare-link": "Žádný kód v inSuite?",
      "language": "Jazyk"
    },
    "scan": {
      "requesting": "Je vyžadován přístup ke kameře…",
      "scanning": "Namiřte fotoaparát na kód",
      "paste": "Místo toho vložte",
      "manual-title": "Připojte se ručně",
      "manual-description": "Pokud QR kód není k dispozici, převezměte údaje o připojení z administrace Bridge.",
      "address-label": "Adresa Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Vložte SOLTOKEN",
      "manual-submit": "Převzít připojení",
      "error-title": "Kód nebyl rozpoznán",
      "camera-denied-title": "Přístup ke kameře odepřen",
      "camera-denied-hint": "Povolte přístup k fotoaparátu v nastavení a zkuste to znovu.",
      "retry": "Zkuste to znovu"
    },
    "preflight": {
      "title": "Bude zřízeno",
      "all-green": "Všechny testy prošly",
      "practice": "Praxe",
      "device-name": "Název zařízení",
      "device-name-placeholder": "např. B. Recepce 1",
      "card-reader": "Čtečka karet",
      "pin": "Nové tajné číslo",
      "pin-placeholder": "Čtyřmístný PIN",
      "finish": "Dokončit",
      "recheck": "Zkontrolujte znovu",
      "diagnosis": "ID diagnózy",
      "checklist-error": "Bridge odmítl připojení nebo není dostupný. Zkontrolujte SOLTOKEN a adresu Bridge.",
      "checklist-retry": "Zkontrolovat znovu",
      "edit-token": "Změnit SOLTOKEN",
      "rescan": "Naskenovat kód znovu"
    },
    "persisting": "Ukládání nastavení …",
    "success": {
      "title": "Zařízení přidáno",
      "detail": "Zařízení se právě objevilo na cvičném PC.",
      "starting": "Spouští se pacientský režim…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Napojení na cvičný software",
        "fix": "Bridge Zkontrolujte připojení a adresu serveru."
      },
      "missing_insuite_url": {
        "label": "Adresa inSuite",
        "fix": "Znovu naskenujte QR kód – adresa chybí."
      },
      "missing_server_token": {
        "label": "Token serveru",
        "fix": "Znovu naskenujte QR kód – chybí token."
      },
      "missing_gateway_session": {
        "label": "Relace Gateway",
        "fix": "Přihlaste se znovu — relace chybí."
      },
      "missing_gateway_enrollment": {
        "label": "Registrace zařízení",
        "fix": "Zaregistrujte zařízení na Gateway."
      },
      "gateway_not_ready": {
        "label": "Připravenost Gateway",
        "fix": "Počkejte, až Gateway dokončí nastavení."
      },
      "token_verification_failed": {
        "label": "Kontrola tokenů",
        "fix": "Zkontrolujte token serveru nebo připojení Bridge."
      },
      "session_expired": {
        "label": "zasedání",
        "fix": "Relace vypršela - přihlaste se znovu."
      },
      "device_revoked": {
        "label": "Stav zařízení",
        "fix": "Toto zařízení bylo zablokováno. Kontaktujte praxi."
      },
      "missing_practice_name": {
        "label": "Název cvičení",
        "fix": "Název lékařské praxe nelze načíst (inSuite)."
      },
      "missing_device_name": {
        "label": "Název zařízení",
        "fix": "Zadejte název zařízení."
      },
      "telematik_unavailable": {
        "label": "Telematická infrastruktura",
        "fix": "Volitelné — kontrola karty je možná, jakmile bude TI k dispozici."
      },
      "selected_card_reader_unavailable": {
        "label": "Čtečka karet",
        "fix": "Volitelné – vyberte nebo připojte čtečku karet."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Volitelné — vložte průkaz lékařské praxe (SMC-B)."
      }
    },
    "token": {
      "title": "Zadejte SOLTOKEN",
      "description": "Z bezpečnostních důvodů QR kód neobsahuje SOLTOKEN. Zkopírujte jej v inSuite v části „Sol-Aktivierung“ (FrontDesk+) a vložte jej sem.",
      "submit": "Pokračovat",
      "rescan": "Naskenovat kód znovu"
    }
  }
}
